import _ from "lodash";
import Meta from "./Meta";

export default class Cell {

    constructor(options = null) 
    {   
        this.meta     = null;
        this.id       = null;
        this.value    = null;

        if( options !== null && _.isObject(options) && options.hasOwnProperty('value') ) {
            this.value = options.value;

            if( options.hasOwnProperty('id') ) {
                this.id = options.id;
            }

            if( options.hasOwnProperty('meta') ) {
                this.setMeta(options.meta);
            }
        } else {
            this.value = options;
        }
    }

    setMeta(meta) {

        if(meta && ! ( meta instanceof Meta ) ) {
            meta = new Meta(meta);
        };

        this.meta = meta;
        return this;
    }

    toString() {
        return this.value;
    }
    
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/Cell.js